export const wrapperStyles = {
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const accordionStyles = {
  boxShadow: 'none',
  '&::before': {
    display: 'none',
  },
  '.MuiAccordionSummary-root': {
    flexDirection: 'row-reverse',
    columnGap: '8px',
    padding: '0 16px',
  },
  '.MuiAccordionDetails-root': {
    padding: 0,
  },
};
